import type { BranchKey } from '@festina-life/api'
import { withLifeErrorBoundary } from '@festina-life/components'
import { useTranslate } from '@festina-life/ui/hooks'
import { withSuspense } from '@festina-life/ui/libs'

import { useConciseBranch } from '../../../../uiModels/branches/useConciseBranch'
import { OperationsLoadedButton } from '../../../operationsButton/OperationsLoadedButton'
import { RebaseBranchPopover } from './RebaseBranchPopover'

type Props = {
  branchKey: BranchKey
}

const RebaseBranchButtonInternal = ({ branchKey }: Props) => {
  const conciseBranch = useConciseBranch({
    server: branchKey.server,
    branchName: branchKey.name,
    shouldFallbackToStandard: false,
  })

  if (!conciseBranch?.baseBranchName) {
    return null
  }

  return (
    <RebaseBranchPopover
      branchKey={branchKey}
      baseBranchKey={{
        name: conciseBranch.baseBranchName,
        server: branchKey.server,
      }}
    />
  )
}

const RebaseLoadingButton = () => {
  const translate = useTranslate()

  return (
    <OperationsLoadedButton startIcon="ArrowPath">
      {translate('branchDetailsPanel.tabs.manage.rebase')}
    </OperationsLoadedButton>
  )
}

export const RebaseBranchButton = withSuspense(
  withLifeErrorBoundary(RebaseBranchButtonInternal),
  { fallback: <RebaseLoadingButton /> },
)
